import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    assessmentName: '',
    description: '',
    assessmentType: '',
    loading: false,
}

const NewExam = () => {

    const [currentNotify, setNotify] = useState(null);
    const { getAssessmentTypes, assessmentTypes, getAssessments} = useConfig();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        getAssessmentTypes();
    }, [])

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(state.assessmentName.length === 0 || state.description.length === 0 || !state.assessmentType.value){
            setNotify(<Notification type='danger' message="Please fill in all fields."/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.createAssessment(state.assessmentName, state.description, state.assessmentType.value);
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            dispatch({type: 'assessmentName', value: ''});
            dispatch({type: 'description', value: ''});
            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            getAssessments(true);
           
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);

        }

    }


      const RenderExams = () => {
        const options = [];
        if (Array.isArray(assessmentTypes) && assessmentTypes.length > 0) {
            assessmentTypes.map((item, key) =>
                options.push({ label: item.type_name, value: item.id })
            );
        }

        return (
            <TextInput
                label="Assessment Type"
                type="select"
                leftIcon={true}
                placeholder={state.assessmentType.label || 'Select assessment type....'}
                options={options}
                onChange={(item) => dispatch({ type: 'assessmentType', value: item })}
                leftComponent={<i className="fa fa-bookmark link" onClick={getAssessmentTypes}></i>}
                loading={!assessmentTypes}
                wrap
            />
        );
    };


  

    return (
        <div className="card-body">

            <CallOut 
                title="New Assessment"
                description="E.g. Class Test, Mid Term, Final Exam, etc."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                        <TextInput
                            type="text"
                            label="Assessment Name"
                            placeholder="Assessment Name"
                            leftIcon="fa fa-edit"
                            value={state.assessmentName}
                            onChange={e => dispatch({type: 'assessmentName', value: e.target.value})}
                            required
                            wrap
                            />

                        <TextInput
                            type="text"
                            label="Description"
                            placeholder="Description"
                            leftIcon="fa fa-list"
                            value={state.description}
                            onChange={e => dispatch({type: 'description', value: e.target.value})}
                            required
                            wrap
                            />

                        {RenderExams()}
                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-primary">Save Exam</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 


        </div>
    );
};

export default NewExam;